/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import * as moment from 'moment';

import Point from '@appLegacy/lib/math/Point';

angular
	.module('ticketspaceApp')
	.directive('fancyCheckbox2', function () {
		return {
			scope: true,
			transclude: true,
			require: '?ngModel',
			link(scope: any, element, attrs, modelCtrl: any) {
				if (!modelCtrl) {
					return;
				}
				element.addClass('fancy-checkbox');

				function assignClasses() {
					if (scope.model) {
						element.addClass('fancy-checkbox-on');
						element.removeClass('fancy-checkbox-off');
					} else {
						element.addClass('fancy-checkbox-off');
						element.removeClass('fancy-checkbox-on');
					}
				}

				modelCtrl.$render = function () {
					scope.model = modelCtrl.$viewValue;
					assignClasses();
				};
				let unwatch = scope.$watch('model', function () {
					modelCtrl.$setViewValue(scope.model);
					assignClasses();
				});

				scope.$on('$destroy', function () {
					unwatch();
				});
			},
			//<span ng-transclude style="padding-left: 36px"></span>\
			template:
				'\
		<label class="">\
			<input type="checkbox" ng-model="model" style="display:none;">\
			<ng-transclude></ng-transclude>\
		</label>\
		',
		};
	})

	.component('periodOffIndicator', {
		template:
			'<div class="promise-period-handle left-handle"><i class="material-icons">chevron_left</i></div><div class="promise-period-handle right-handle"><i class="material-icons">chevron_right</i></div>',
		bindings: {
			periodService: '<',
			orderedExecutor: '<',
			hud: '<',
		},
		controller: [
			'$element',
			function ($element) {
				let ctrl = this;

				let leftSide = $element.find('.left-handle');
				let rightSide = $element.find('.right-handle');

				leftSide.addClass('hide');
				rightSide.addClass('hide');

				this.$onInit = function (changesObj) {
					ctrl.orderedExecutor.add(function () {
						if (
							!ctrl.periodService.range ||
							!ctrl.periodService.range.startX ||
							!ctrl.periodService.range.endX
						) {
							leftSide.addClass('hide');
							rightSide.addClass('hide');
							return;
						}
						if (ctrl.hud) {
							let leftScreenX = ctrl.hud.realToScreenX(ctrl.periodService.range.endX);
							if (leftScreenX < 84) {
								leftSide.removeClass('hide');
							} else {
								leftSide.addClass('hide');
							}

							let rightScreenX = ctrl.hud.realToScreenX(ctrl.periodService.range.startX);
							if (rightScreenX > window.innerWidth) {
								rightSide.removeClass('hide');
							} else {
								rightSide.addClass('hide');
							}
						}
					});
				};
			},
		],
	});
